import { Navigate, Outlet } from "react-router-dom";
import AppLayout from "../components/layout/AppLayout";
import ProtectedRoute from "./protected_route";
// import CloudAgent from "../pages/organization/cloudAgent/CloudAgent";
import CloudAgent2 from "../pages/organization/cloudAgent/CloudAgent2";
import NewScan from "../pages/onPremises/newScan/NewScan";
import NewScanV2 from "../pages/onPremises/newScanV2/NewScanV2";
import Vpn from "../pages/organization/vpn";
import CustomPorts from "../pages/organization/customPorts";
import Roles from "../pages/organization/Roles";
import NotFound from "../pages/NotFound";

import IdleTimeout from "../modules/authentication/idleTimeOut";
import EventsManager from "../components/socket/event-manager";
import MyScanTable from "../pages/onPremises/myScan/MyScanTable";


import { UserManagementTable } from "../pages/userManagement";
import CVEScreen from "../pages/onPremises/cve";

import ScanInformation from "../pages/onPremises/myScan/ScanInformation";
import ScheduleMain from "../pages/onPremises/scheduleScans/ScheduleMain";
import RiskAcceptancePage from "../pages/risk-acceptance/RiskAcceptancePage";
import AssetsDetails from "../pages/onPremises/assetsManagement/AssetsDetails";
import AssetsDetailsV2 from "../pages/onPremises/assetsManagement/AssetsDetailsV2";
import ScanDetails from "../pages/onPremises/myScan/ScanDetails/ScanDetails";
import { SecurityInformation } from "../pages/SecurityPosture";
import CredentionalMgmt from "../pages/onPremises/CredentionalManagement/CredentionalMgmt";
import ComplianceDashboard from "../pages/ComplianceDashboard";
import ComplianceDetailsPage from "../pages/ComplianceDetailsPage";
import DoTResultsPage from "../pages/DoTCompliance/DoTResultsPage";
import RegionManagement from "../pages/organization/RegionManagement";
import CloudAssetDetails from "../pages/onPremises/assetsManagement/CloudAssetsDetails";
import NewAssets from "../pages/onPremises/assetsManagement/NewAssets";
import Home from "../pages/Dashboard/Home";
import Unauthorized from "../pages/UnAuthorized";
import Discovery from "../pages/discovery/Discovery";
import AwsInventory from "../pages/cloud/AwsInventory";
import Reports from "../pages/Reports/Reports";
import Software from "../pages/Software/Software";
import ConfigDiff from "../pages/onPremises/ConfigDiff/ConfigDiff";
import ShowConfigDiffPage from "../pages/onPremises/ConfigDiff/ShowConfigDiffPage";
import RuleManagement from "../pages/RuleManagement/RuleManagement";
import { ScansV2Page } from "../pages/onPremises/scansV2";
import DiscoverySecurityPage from "../pages/onPremises/scansV2/DiscoverySecurityPage";
import MasterConfig from "../pages/organization/MasterConfig";




const MainRoutes = {
  path: "/",
  element: (
    <ProtectedRoute>
      <EventsManager />
      <AppLayout>
        <IdleTimeout />
        <Outlet />
      </AppLayout>
    </ProtectedRoute>
  ),
  children: [
    {
      path: "dashboard",
      element: <Home />,
    },
    {
      path: "discovery",
      element: <Discovery />,
    },
    {
      path: "aws-discovery",
      element: <AwsInventory />,
    },
    // {
    //   path: "organization/agent",
    //   element: <CloudAgent />,
    // },
    {
      path: "organization/agent",
      element: <CloudAgent2 />,
    },
    {
      path: "/on-premises/newscan",
      element: <NewScan />,
    },
    {
      path: "/on-premises/new-newscan",
      element: <NewScanV2 />,
    },
    {
      path: "/on-premises/cve",
      element: <CVEScreen />,
    },
    {
      path: "organization/vpn",
      element: <Vpn />,
    },
    {
      path: "organization/custom-ports",
      element: <CustomPorts />,
    },
    {
      path: "organization/roles",
      element: <Roles />,
    },
    {
      path: "organization/reports",
      element: <Reports />,
    },
    {
      path: "organization/master-config",
      element: <MasterConfig />,
    },
    {
      path: "on-premises/scans-1",
      element: <MyScanTable key="onprem" />,
    },
    {
      path: "on-premises/scans",
      element: <ScansV2Page />,
    },
    {
      path: "cloud/scans",
      element: <MyScanTable key="clouds" />,
    },
    {
      path: "onprem/scan/:scan_uuid",
      element: <ScanDetails key="onprem" />,
    },
    {
      path: "cloud/scan/:scan_uuid",
      element: <ScanDetails key="clouds" />,
    },
    {
      path: "on-premises/discovery-security/:scan_uuid",
      element: <DiscoverySecurityPage />,
    },
    {

      path: "on-premises/security-posture",
      element: <SecurityInformation key="onprem" />,
    },
    {
      path: "cloud/rule-management",
      element: <RuleManagement key="clouds" />,
    },
    {

      path: "cloud/security-posture",
      element: <SecurityInformation key="clouds" />,
    },
    {
      path: "organization/user-management",
      element: <UserManagementTable />,
    },
    {
      path: "on-premises/new-assets/:assets_id",
      element: <NewAssets />,
    },
    {
      path: "on-premises/scan-details/:scan_uuid",
      element: <ScanInformation />,
    },
    {
      path: "cloud/scan-details/:scan_uuid",
      element: <ScanInformation />,
    },
    // {
    //   path:'onprem/schedule/:id',
    //   element:<ScheduleScan></ScheduleScan>
    // },
    // {
    //   path:'onprem/schedule',
    //   element:<ScheduleScan></ScheduleScan>
    // },
    {
      path: 'onprem/schedule/:scan_uuid',
      element: <ScheduleMain />
    },
    {
      path: 'onprem/schedule',
      element: <ScheduleMain />
    },
    {
      path: 'on-premises/acceptedrisk',
      element: <RiskAcceptancePage />,
    },
    {
      path: "on-premises/assets",
      element: <AssetsDetails key="onprem" />,
    },
    {
      path: "on-premises/asset_v2",
      element: <AssetsDetailsV2 key="onprem_v2" />,
    },
    {
      path: "cloud/cloud-resources",
      element: <CloudAssetDetails key="clouds" />,
    },
    {
      path: "cloud/rule-management",
      element: <RuleManagement key="clouds" />,
    },
    {
      path: "on-premises/credentials",
      element: <CredentionalMgmt />,
    },
    {
      path: "compliance-dashboard",
      element: <ComplianceDashboard />,
    },
    {
      path: "compliance-dashboard/dot/checklist",
      element: <Navigate to="/compliance-dashboard/dot" replace />,
    },
    {
      path: "compliance-dashboard/dot",
      element: <DoTResultsPage />,
    },
    {
      path: "compliance-dashboard/:control_type",
      element: <ComplianceDetailsPage />
    },
    {
      path: "on-premises/installed-software",
      element: <Software />
    },
    {
      path: "on-premises/configdiff",
      element: <ConfigDiff />
    },
    {
      path: "on-premises/configdiff/show-diff",
      element: <ShowConfigDiffPage />
    },
    {
      path: "unauthorized",
      element: <Unauthorized />,
    },
    {
      path: "/unauthorized",
      element: <Unauthorized />,
    },
    // 404 catch-all route
    {
      path: "*",
      element: <NotFound />,
    },
  ],
};

export default MainRoutes;
